// services/userService.js or services/apiEndpoints.js

import { API_URL } from "../server";

export const userservice = {
  userRegistration: API_URL + 'userRegistration',
  otpverify: API_URL + 'userOtpVerify',
  createPassword: API_URL + 'createNewPassword',
  login: API_URL + 'userLogin',
  forgetPassword: API_URL + 'forgetPassword',
  verifyOtpForPasswordReset: API_URL + 'verifyOtpForPasswordReset',
  expertApprovalStatus: API_URL + 'getBexomeExpertById',
  getAdminSessionPrice: API_URL + 'getAdminSessionPrice',

};
